import { Tab, TabProps, Theme, useTheme } from '@mui/material';
import { CSSProperties, ElementType, ReactElement } from 'react';

const swingWidth = 40;
const swingSteepness = 12;
const boxWidth = 40;

function getTextWidth(text: string, theme: Theme): number {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');

  if (!context) {
    return 0;
  }

  context.font = `${theme.typography.fontWeightBold} ${theme.typography.body1.fontSize} ${theme.typography.body1.fontFamily}`;

  return context ? context.measureText(text).width : 0;
}

function makeSweptStyle(width: number, height: number, borderRadius = 10): CSSProperties {
  return {
    paddingRight: '40px',
    marginRight: '-13px',
    width: `${width + boxWidth}px`,
    height: `${height}px`,
    clipPath: `path("
      M 0 ${height}
      V${borderRadius}
      Q 0 0 ${borderRadius} 0
      H${width + boxWidth - swingWidth}
      q ${swingSteepness} 0 ${swingWidth / 2} ${height / 2}
      T ${width + boxWidth} ${height}
    ")`.replace(/\s+/g, ' '),
  };
}

export type SweptTabProps<D extends ElementType, P> = Omit<TabProps<D, P>, 'label'> & {
  label?: string;
};

export function SweptTab<D extends ElementType, P>({ sx, ...props }: SweptTabProps<D, P>): ReactElement {
  const theme = useTheme();

  return (
    <Tab
      sx={[
        {
          ...makeSweptStyle(getTextWidth(props.label ?? '', theme), 48),
          '&:first-of-type': {
            marginLeft: '1rem',
          },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...props}
    />
  );
}
